import { render, staticRenderFns } from "./UserGroupEdit.vue?vue&type=template&id=aa9d9b02&scoped=true"
import script from "./UserGroupEdit.vue?vue&type=script&lang=js"
export * from "./UserGroupEdit.vue?vue&type=script&lang=js"
import style0 from "./UserGroupEdit.vue?vue&type=style&index=0&id=aa9d9b02&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa9d9b02",
  null
  
)

export default component.exports